import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './FooterDesktop.css';

const FooterDesktop = ({ footerDesktopExpanded }) => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <div className={`footer__desktop ${footerDesktopExpanded ? 'footer__desktop--expanded' : ''}`} >
        <div className="footer__content">
          <p><Link to={{ pathname: '/privacy', state: { prevPath: window.location.pathname } }}>{t('footer:Privacy')}</Link> © {t('footer:Maxxam 2013 All rights reserved&#46; Success Through Science')}® | <Link to={{ pathname: '/terms', state: { prevPath: window.location.pathname } }}>{t('footer:Terms and Conditions')}</Link></p>
          <p>API and UI Last updated at: {process.env.UPDATED_AT}</p>
        </div>
      </div>

    </Fragment>
  );
};

FooterDesktop.propTypes = {
  footerDesktopExpanded: PropTypes.bool,
};

export default FooterDesktop;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterDesktop/FooterDesktop.jsx